module.exports = __webpack_public_path__ + "media/images/company/cp10-9e356e62b44583e8f2f088cac35db535.png";